import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row } from 'react-materialize';
import { withTranslation } from 'react-i18next';
import { Select } from '../../../../components/UI/ComponentsUI';
import { translate, isNullOrEmpty, newObjArray } from '../../../../utils/util';
import { ENUMS } from '../../../../utils/constants';
import ConfigurationService from '../../../../services/ConfigurationService';

const SelectResourceForm = (props) => {
    const [print, setPrint] = useState();
    const [resourcesFilter, setResourcesFilter] = useState([]);

    useEffect(() => {
        setPrint();
        if (props.resources && props.resources.length > 0) {
            let filter = props.resources.filter((f) => f.printer.connectionType === ENUMS.ePrinterConnectionType.Wifi.value && f.printer.laser)
            setResourcesFilter(newObjArray(filter));
        } else {
            props.getResourcesAll();
        }
        // eslint-disable-next-line
    }, [props.resources]);

    const onChangeResource = (el) => {
        if (!isNullOrEmpty(el.target.value)) {
            let resource = props.resources.find((i) => i.resourceId === parseInt(el.target.value));
            if (resource?.printer) {
                setPrint(resource?.printer);
                props.onChangePrinter(resource?.printer)
            }
        }
        else {
            setPrint();
            props.onChangePrinter(undefined)
        }
    }

    return (
        <div className="col s12" style={{ paddingBottom: '5px', paddingTop: '20px' }}>
            <div className="input-field col s12">
                <Select
                    id="resource"
                    name="resource"
                    valuefield="resourceId"
                    display="name"
                    label={translate('resource', 'physical-confirmation')}
                    placeHolder={translate('choose-one-option', 'general')}
                    data={resourcesFilter}
                    change={onChangeResource}
                />
            </div>
            {print &&
                <Row className="center">
                    <div className="sixth-text-color center">
                        <span className="title col s12">{print.name}</span>
                        <span className="col s12" >{print.address} - {print.port}</span>
                    </div>
                </Row>}

        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        resources: state.logisticsResourceReducer.list
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getResourcesAll: () => {
            dispatch(ConfigurationService.getResourcesAll());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectResourceForm));